import organizations from './organizations'
import offices from './offices'
import actions from './actions'

export default {
  partner: {
    namespaced: true,
    modules: {
      organizations,
      offices,
      actions
    }
  }
}
